import { formatCustomDate } from "helpers/dateTools";

export const initialValues = {
    values: {
        idStation: null,
        idBrand: null,
        brandName: '',
        code: '',
        productType: null,
        discountType: null,
        discount: null,
        minPurchase: 0,
        redemptionLimit: null,
        startDate: formatCustomDate(new Date(), '-'),
        endDate: formatCustomDate(new Date(), '-'),
        purchaseNumber: null,
        usesPerCustomer: null,
        status: 'ACTIVE'
    },
    required: {
        idStation: { required: true },
        idBrand: { required: true },
        code: { required: true, minLength: 3 },
        discountType: { required: true },
        discount: { required: true, isNumber: true },
        startDate: { required: true },
        endDate: { required: true }
    }
}